define('cartware/objectpool/image',[],function() {
	var instance = null;

	function ImagePool() {
		this._warm();
	}

	ImagePool.getInstance = function() {
		if (null === instance) {
			instance = new ImagePool();
		}

		return instance;
	}

	ImagePool.prototype = {
		_used: [],
		_free: [],
		_gcInterval: null,

		_warm: function() {
			var img;
			for (var i = 0; i < 10; i++) {
				img = new Image;
				img._recycleCount = 0;
				img.src = "";

				this._free.push(img);
			}

			if (!this._gcInterval) this._initGc();
		},

		_initGc: function() {
			var self = this
				, callback = function() {
					self._gc.call(self);
				};

			if (!this._gcInterval) {
				this._gcInterval = setInterval(callback, 3000);
			}
		},

		_pauseGc: function() {
			if (this._gcInterval) {
				clearTimeout(this._gcInterval);
				this._gcInterval = null;
			}
		},

		_gc: function() {
			for (var i = 0, l = this._free.length; i < l; i++) {
				this._resetObject(this._free[i]);
			}

			this._free = [];

			if (!this._used.length) this._pauseGc();
		},

		_resetObject: function(img) {
			img.onload = null;
			img.onerror = null;
			img.src = "";

			if ("TRANSPORT" in img) img.TRANSPORT = null;

			img._recycleCount++;

			return img;
		},

		alloc: function() {
			var img;

			if (!this._free.length) this._warm();

			img = this._free.pop();

			this._used.push(img);

			return img;
		},

		release: function(img) {
			var index = this._used.indexOf(this._resetObject(img));
			if (index >= 0) this._free.push(this._used.splice(index, 1)[0]);
		}
	};

	return ImagePool;
});
